export default "__VITE_ASSET__B8OlY5Lg__"